import { getRecoil, setRecoil } from 'recoil-nexus';

import { showAlert } from 'components/shared/Alert/Alert';
import { clinicalNote as clinicalNoteState, intelligenceAiState } from 'components/state';
import { enhanceAmbientListeningLoading } from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/AmbientListening/state';
import {
  enhanceNoteLoadingState,
  isAIGeneratingState,
  myScribeAILoadingState
} from 'components/practice/charts/ClinicalNote/MyScribeAI/state';

import { resetAutoMapGenerationState } from './lib/updateAutoMapTemplate';

const NON_CHAT_PROMPT_KINDS = ['narrative', 'enhance_note', 'description', 'ambient_listening'];

const isForCurrentNote = (data, { requireNoteId = false } = {}) => {
  const currentNoteId = getRecoil(clinicalNoteState)?.id;
  if (data?.destId == null || currentNoteId == null) return !requireNoteId;
  return Number(data.destId) === Number(currentNoteId);
};

const shouldResetChatGeneration = (data) =>
  !NON_CHAT_PROMPT_KINDS.includes(data?.promptKind) && isForCurrentNote(data);

export default (data) => {
  if (data?.promptKind === 'narrative' && data?.formName) {
    setRecoil(enhanceNoteLoadingState, (prev) => {
      const index = prev.findIndex((item) => item === data.formName);
      if (index === -1) return prev;

      const newValue = [...prev];
      newValue.splice(index, 1);

      return newValue;
    });
  } else if (data?.promptKind === 'ambient_listening') {
    if (isForCurrentNote(data, { requireNoteId: true })) {
      setRecoil(enhanceAmbientListeningLoading, false);
    }
  } else if (shouldResetChatGeneration(data)) {
    setRecoil(myScribeAILoadingState, false);
    setRecoil(isAIGeneratingState, false);
    resetAutoMapGenerationState();
  }

  const message =
    (typeof data?.error === 'string' && data.error) ||
    (typeof data?.error?.message === 'string' && data.error.message) ||
    'MyScribe AI could not generate a response. Please try again.';
  showAlert({ title: 'MyScribe AI', message, color: 'danger' });

  const aiTimeout = getRecoil(intelligenceAiState);
  clearTimeout(aiTimeout?.timeoutTimeout);
  setRecoil(intelligenceAiState, (ps) => ({
    ...ps,
    timeoutTimeout: null
  }));
};
